"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class AvailableGateway extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'availableGateway';
        this._serialNumber = initParams.serial_number;
        this._owners = (0, util_1.camelArray)(initParams.owners);
    }
    set serialNumber(value) {
        console.error('Do not set objects this way');
    }
    setSerialNumber(value) {
        return this.dataService.updateAvailableGateway(this.id, { serial_number: value }, this);
    }
    get serialNumber() {
        return this._serialNumber;
    }
    set owners(value) {
        console.error('Do not set objects this way');
    }
    setOwners(value) {
        return this.dataService.updateAvailableGateway(this.id, { owners: (0, util_1.snakeArray)(value) }, this);
    }
    get owners() {
        return this._owners;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAvailableGateway(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = AvailableGateway;
//# sourceMappingURL=availableGateway.js.map